import { Button, Layout, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useForm } from 'antd/es/form/Form'
import { get, put } from '../../Common/api'
import { t } from 'i18next'
import UserForm from '../UsersPage/UserForm'
import { notificationError, notificationSuccess } from '../../Common/Common'

export default function UserPage () {
  const { id } = useParams()
  const [form] = useForm()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getUser()
  }, [])

  const getUser = async () => {
    setLoading(true)
    await get(`admin/users/${id}`, {}, (json) => {
      setLoading(false)
      form.setFieldsValue(json)
    }, () => {
      setLoading(false)
    })
  }

  const onFinish = (values) => {
    saveUser(values)
  }

  const saveUser = (params) => {
    setLoading(true)
    put(`admin/users/${id}`, params, () => {
      setLoading(false)
      notificationSuccess('update')
    }, (errors) => {
      setLoading(false)
      notificationError('update')
      form.setFields(
        Object.keys(errors).map((key) => ({
          name: key,
          errors: errors[key]
        }))
      )
    })
  }

  return (
    <Layout style={{ padding: '1em', backgroundColor: 'white', marginTop: '2em' }}>
      <Spin spinning={loading}>
          <UserForm form={form} edit={true} onFinish={onFinish} />
          <Button type="primary" htmlType="submit" onClick={form.submit}>
            {t('Admin.btn.submit')}
          </Button>
      </Spin>
    </Layout>
  )
}
